// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__wA4Fy","checkbox_active":"Checkbox_checkbox_active__1vwc7"};